(function(){
  
  // ALWAYS ensure session ID exists (even before vehicle selection)
  var sessionId = sessionStorage.getItem('ymm_session_id');
  if(!sessionId){
    sessionId = 'sess_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
    sessionStorage.setItem('ymm_session_id', sessionId);
  } else {
  }
  
  // Determine current page type
  var currentPath = window.location.pathname;
  var pageType = 'other';
  if (currentPath === '/' || currentPath === '') {
    pageType = 'home';
  } else if (currentPath.indexOf('/collections/') !== -1) {
    pageType = 'collection';
  } else if (currentPath.indexOf('/products/') !== -1) {
    pageType = 'product';
  } else if (currentPath.indexOf('/cart') !== -1) {
    pageType = 'cart';
  }
  
  // Get shop info
  var shop = window.Shopify && window.Shopify.shop ? window.Shopify.shop : '';
  if(!shop) {
    return;
  }
  
  // Get current page info
  var pagePath = window.location.pathname;
  var pageTitle = document.title || pagePath;
  
  // Check if vehicle is selected (determines if session is "engaged")
  var cachedData = sessionStorage.getItem('ymm_vehicle_selection');
  var hasVehicle = !!cachedData;
  var vehicleData = null;
  
  if(hasVehicle) {
    try {
      vehicleData = JSON.parse(cachedData);
    } catch(e) {
      hasVehicle = false;
    }
  } else {
  }
  
  // Get source - only matters if vehicle is selected
  var source = hasVehicle ? (sessionStorage.getItem('ymm_source') || 'unknown') : null;
  
  // Build tracking data
  var trackingData = {
    page: {
      path: pagePath,
      title: pageTitle,
      url: window.location.href,
      type: pageType
    }
  };
  
  // Add vehicle data if exists
  if(hasVehicle && vehicleData) {
    trackingData.vehicle = vehicleData;
  }
  
  // Build URL with all parameters
  var trackUrl = '/apps/ymm/track-pageview?sessionId=' + encodeURIComponent(sessionId) + 
                 '&shop=' + encodeURIComponent(shop) + 
                 '&page=' + encodeURIComponent(pagePath) +
                 '&engaged=' + (hasVehicle ? 'true' : 'false');
  
  // Add source if vehicle is selected
  if(source) {
    trackUrl += '&source=' + encodeURIComponent(source);
  }
  
  
  // Send page view tracking for ALL sessions (engaged or not)
  fetch(trackUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(trackingData),
    keepalive: true
  })
  .then(function(response) {
    return response.json();
  })
  .then(function(data) {
  })
  .catch(function(error) {
  });
})();

// ── Y6: sync the verified YMM vehicle to the visitor's Klaviyo profile ──────
// Lets email segments target by what people actually drive. Fires on fitment
// verify (the widget's ymm:verified event) and on identity creation (Klaviyo
// form submit) while a verified vehicle already sits in sessionStorage. Fully
// guarded — every external call is wrapped so it can never throw, and it does
// nothing if Klaviyo isn't present. Touches no widget/front-end code; reads
// sessionStorage only; never touches 9yy- tags.
(function(){
  var KEYS = ['Year','Make','Model','Drive','Engine'];
  function getVehicle(){
    try { return JSON.parse(sessionStorage.getItem('ymm_vehicle_selection') || 'null'); }
    catch(e){ return null; }
  }
  function complete(v){
    if(!v) return false;
    for(var i=0;i<KEYS.length;i++){ if(!v[KEYS[i]]) return false; }
    return true; // guard: never push a partial selection
  }
  // Identified = Klaviyo cookie carries an identity. $email is written by
  // form submits; $exchange_id is what EMAIL CLICK-THROUGHS and js identify()
  // set (QA 2026-07-16: $email-only guard silently skipped click-through
  // visitors — the highest-intent segment). identify(props) attaches to the
  // active profile in both cases. Anonymous visitors are skipped at verify.
  function isIdentified(){
    try {
      var m = document.cookie.match(/(?:^|;\s*)__kla_id=([^;]+)/);
      if(!m) return false;
      var j = JSON.parse(atob(decodeURIComponent(m[1])));
      return !!(j && (j['$email'] || j['$exchange_id']));
    } catch(e){ return false; }
  }
  var lastPushed = null;
  function push(v){
    if(!complete(v)) return;
    var key = KEYS.map(function(k){ return v[k]; }).join('|');
    if(key === lastPushed) return;
    var props = {
      vehicle_year:   String(v.Year),
      vehicle_make:   String(v.Make),
      vehicle_model:  String(v.Model),
      vehicle_drive:  String(v.Drive),
      vehicle_engine: String(v.Engine),
      vehicle_updated_at: new Date().toISOString()
    };
    try {
      if(window.klaviyo && typeof window.klaviyo.identify === 'function'){
        window.klaviyo.identify(props); // latest verified wins (overwrite)
      } else if(window._learnq){
        window._learnq.push(['identify', props]);
      } else {
        return; // Klaviyo not loaded — do nothing
      }
      lastPushed = key;
    } catch(e){}
  }
  function maybePush(){
    var v = getVehicle();
    if(complete(v) && isIdentified()) push(v);
  }
  try {
    // Trigger 1 — fitment verified (all five fields resolved).
    document.addEventListener('ymm:verified', function(e){
      var v = (e && e.detail && e.detail.fields) || getVehicle();
      if(complete(v) && isIdentified()) push(v);
    });
    // Trigger 2 — identity just created (popup signup / checkout) while a
    // verified vehicle is already stored.
    window.addEventListener('klaviyoForms', function(e){
      if(e && e.detail && /submit/i.test(e.detail.type || '')){
        setTimeout(maybePush, 1500);
      }
    });
    // Returning identified visitor who verified earlier this session.
    if(document.readyState !== 'loading') maybePush();
    else document.addEventListener('DOMContentLoaded', maybePush);
  } catch(e){}
})();

